import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=57dd3436&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=57dd3436&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dd3436",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57dd3436')) {
      api.createRecord('57dd3436', component.options)
    } else {
      api.reload('57dd3436', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=57dd3436&scoped=true", function () {
      api.rerender('57dd3436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/audio/Index.vue"
export default component.exports